<template>
  <div class="company-profile-widget">
    <!-- company-profile display -->
    <div class="company-profile-container" v-animate-css="'fadeIn'">
      <div class="company-profile-body">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: tab == 'man_info' }"
            @click="tab = 'man_info'"
          >
            Manager information
          </div>
          <div
            class="tab"
            :class="{ active: tab == 'comp_info' }"
            @click="tab = 'comp_info'"
          >
            Company information
          </div>
          <div
            class="tab"
            :class="{ active: tab == 'sec_info' }"
            @click="tab = 'sec_info'"
          >
            Security information
          </div>
          <div
            class="tab"
            :class="{ active: tab == 'term_tab' }"
            @click="tab = 'term_tab'"
          >
            Terms & Conditions
          </div>
        </div>
        <div class="tab-body man_info" v-show="tab == 'man_info'">
          <div class="company-input-group col-2">
            <div class="input">
              <label>First name</label>
              <input
                type="text"
                class="company-input"
                placeholder="First name"
                name="first_name"
                v-model="manager_form.first_name"
                v-validate="'required'"
              />
              <span class="error_alert" v-if="errors.has('form-1.first_name')"
                >First name is required</span
              >
            </div>

            <div class="input">
              <label>Last name</label>
              <input
                type="text"
                class="company-input"
                placeholder="Last name"
                name="last_name"
                v-model="manager_form.last_name"
                v-validate="'required'"
              />
              <span class="error_alert" v-if="errors.has('form-1.last_name')"
                >Last name is required</span
              >
            </div>
          </div>
          <div class="company-input-group col-2">
            <div class="input">
              <label>Telephone</label>
              <input
                type="text"
                class="company-input"
                placeholder="Phone"
                name="phone"
                v-model="manager_form.phone"
                v-validate="'required'"
              />
              <span class="error_alert" v-if="errors.has('form-1.phone')"
                >Phone is required</span
              >
            </div>
            <div class="input">
              <label>Location</label>
              <map-helper v-model="manager_form.manager_address"></map-helper>
              <span class="error_alert" v-if="errors.has('form-1.address')"
                >Locationis required</span
              >
            </div>
          </div>

          <div class="company-input-group">
            <div class="input">
              <label>Description</label>
              <html-editor
                v-model="manager_form.manager_description"
                id="edit-descr"
              />
              <span
                class="error_alert"
                v-if="errors.has('form-1.manager_description')"
                >Manager description is required</span
              >
            </div>
          </div>
          <div class="profile-cover-upload-widget">
            <div class="profile-image">
              <label>Profile image</label>
              <upload
                :crop="true"
                @onFileSelected="setManagerProfileLogo"
                :value="{
                  url: $fullUrl('images/profiles/'),
                  file_name: manager_form.profile_logo_url,
                }"
              />
            </div>
            <div class="cover-image">
              <label>Cover image</label>
              <div class="cover-upload-widget">
                <div class="cover-upload">
                  <upload
                    :crop="true"
                    :ration="10 / 1"
                    @onFileSelected="setManagerCoverLogo"
                    :value="{
                      url: $fullUrl('images/covers/'),
                      file_name: manager_form.cover_image_url,
                    }"
                  />
                </div>
                <div class="default-cover-image">
                  <div
                    class="cover-image-item"
                    v-for="index in 2"
                    :key="index"
                    :class="{
                      active:
                        manager_form.cover_image_url == index - 1 + '.png',
                    }"
                    @click="setCoverImage(index - 1 + '.png')"
                  >
                    <img
                      :src="$fullUrl('images/covers/' + (index - 1) + '.png')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="options-widget">
            <consultfied-button
              @click="submitManagerInfo()"
              class="btn-save"
              :loading="loading"
              >Save</consultfied-button
            >

            <button class="btn-cancel" @click="onCancel()">Cancel</button>
          </div>
        </div>
        <div class="tab-body comp_info" v-show="tab == 'comp_info'">
          <h2 class="tab-title">Company information</h2>
          <div class="company-input-group col-2">
            <div class="input">
              <label>Company name</label>
              <input
                type="text"
                class="company-input"
                placeholder="Company name"
                name="company_name"
                v-validate="'required'"
                v-model="company_form.company_name"
              />
              <span class="error_alert" v-if="errors.has('form-1.company_name')"
                >Company name is required</span
              >
            </div>

            <div class="input">
              <label>Company domain</label>
              <input
                type="text"
                class="company-input"
                placeholder="Domain"
                name="company_domain"
                v-validate="'required'"
                v-model="company_form.company_domain"
              />
              <span
                class="error_alert"
                v-if="errors.has('form-1.company_domain')"
                >Company domain is required</span
              >
            </div>
          </div>
          <div class="company-input-group col-2">
            <div class="input">
              <label>Location</label>
              <map-helper v-model="company_form.company_address"></map-helper>
              <span class="error_alert" v-if="errors.has('form-1.address')"
                >Locationis required</span
              >
            </div>
          </div>
          <div class="company-input-group">
            <div class="input">
              <label>Company description</label>
              <html-editor
                v-model="company_form.company_description"
                id="edit-descr"
              />
              <span
                class="error_alert"
                v-if="errors.has('form-1.company_description')"
                >Company description is required</span
              >
            </div>
          </div>
          <div class="company-input-group">
            <div class="input">
              <div class="company-logo">
                <label>Logo image</label>
                <upload
                  :crop="true"
                  @onFileSelected="setCompanyProfileLogo"
                  :value="{
                    url: $fullUrl('images/profiles/'),
                    file_name: company_form.profile_logo_url,
                  }"
                />
              </div>
            </div>
          </div>

          <div class="options-widget">
            <consultfied-button
              @click="submitCompanyInfo()"
              class="btn-save"
              :loading="loading"
              >Save</consultfied-button
            >
            <button class="btn-cancel" @click="onCancel()">Cancel</button>
          </div>

          <div class="consultant-widget" v-if="false">
            <div class="company-profile-body">
              <ul class="consultants-items">
                <li class="consultants-starter">
                  <div class="consultants-item-header">
                    <label>Manager</label>
                    <button class="btn-add-member">Add a new member</button>
                  </div>
                </li>
                <li class="consultants-item" v-for="i in 0" :key="i">
                  <panel-expand :expand="false">
                    <template v-slot:header>
                      <div class="consultants-item-header">
                        <div class="consultants-item-brand">
                          <!-- <img
                      v-if="item.user.customer_profile.logo"
                      :src="$fullUrl('images/profiles/'+item.user.customer_profile.logo)"
                      alt
                            />-->
                          <img src="@/assets/icons/logo_avatar.svg" alt />
                        </div>
                        <div class="content">
                          <div class="information">
                            <label>Manager name</label>
                            <span>Paris, France</span>
                          </div>
                          <div class="options">
                            <span class="admin-label">Admin</span>
                            <span class="manager-label">Manager</span>
                            <!-- Dropdown -->
                            <dropdown-menu>
                              <ul>
                                <li>
                                  <a href="#">Edit Profile</a>
                                </li>
                                <li>
                                  <a href="#">Delete Manager</a>
                                </li>
                              </ul>
                            </dropdown-menu>
                            <!-- End of dropdown -->
                          </div>
                        </div>
                      </div>
                    </template>
                  </panel-expand>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tab-body sec_info" v-show="tab == 'sec_info'">
          <h4 class="tab-title">Change Password</h4>
          <div class="form-widget">
            <div class="input-widget">
              <div class="input">
                <label>
                  Current Password
                  <span class="required">*</span>
                </label>
                <input type="password" v-model="security_form.current_pass" />
              </div>
              <div class="option">
                <a
                  href="#"
                  @click.prevent="$router.push({ name: 'forgot-password' })"
                  >Forgot password</a
                >
              </div>
            </div>
            <div class="input-widget">
              <div class="input">
                <label>New Password</label>
                <input type="password" v-model="security_form.new_password" />
              </div>
            </div>
            <div class="input-widget">
              <div class="input">
                <label>Comfirm Password</label>
                <input type="password" v-model="security_form.comfirm_pass" />
              </div>
            </div>
            <div class="form-option">
              <consultfied-button
                @click="updatePassword()"
                class="btn-save"
                :loading="loading"
                >Save</consultfied-button
              >
              <button class="btn-cancel" @click="onCancel()">Cancel</button>
            </div>
          </div>
          <div class="other-options">
            <!-- <consultfied-button
                @click="deleteCompany()"
                class="btn-delete-company"
                :loading="company_delete_loading"
              >Delete Company</consultfied-button>-->
            <app-dialog
              title="Account Deletion"
              ask="Are you sure you want to delete this account?"
              yesText="Accept"
              noText="Cancel"
              yesBtnClass="btn-default"
              @onComfirm="deleteAccount()"
            >
              <consultfied-button
                class="btn-delete-account"
                :loading="account_delete_loading"
                >Delete Account</consultfied-button
              >
            </app-dialog>
          </div>
        </div>
        <div class="tab-body term_tab" v-show="tab == 'term_tab'">
          <terms-widget />
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import upload from "@/components/Partials/Uploader.vue";
import panelExpand from "@/components/Partials/panelExpand";
import dropdownMenu from "@/components/Partials/dropdownMenu";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import TermsWidget from "@/components/TermsWidget.vue";
export default {
  name: "companySettings",
  components: {
    upload,
    panelExpand,
    dropdownMenu,
    consultfiedButton,
    TermsWidget,
  },
  props: {},
  data: () => {
    return {
      tab: "comp_info",
      isScoll: false,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
      },
      manager_form: {
        id: null,
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        manager_address: "",
        manager_description: "",
        profile_logo: null,
        profile_logo_url: "",
        cover_image: null,
        default_cover_image: "",
        cover_image_url: "",
        profile_logo_set: true,
        cover_image_set: true,
      },
      company_form: {
        id: null,
        company_name: "",
        company_domain: "",
        company_address: "",
        company_description: "",
        profile_logo: null,
        profile_logo_url: "",
        profile_logo_set: true,
      },
      security_form: {
        current_pass: "",
        new_password: "",
        comfirm_pass: "",
      },
      loading: false,
      account_delete_loading: false,
      company_delete_loading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.$store.dispatch("GET_COUNTRIES");
    vm.$store
      .dispatch("GET_ME_USER_COMPANY")
      .then((responce) => {
        vm.user = responce.data;
        // Set manager data
        vm.manager_form.id = vm.user.manager_info.id;
        vm.manager_form.first_name = vm.user.manager_info.first_name;
        vm.manager_form.last_name = vm.user.manager_info.last_name;
        vm.manager_form.email = vm.user.manager_info.email;
        vm.manager_form.phone = vm.user.manager_profile.phone;
        vm.manager_form.manager_address = vm.user.manager_profile.address;
        vm.manager_form.manager_description =
          vm.user.manager_info.profile.description;
        vm.manager_form.profile_logo = null;
        vm.manager_form.profile_logo_url = vm.user.manager_info.profile_picture;
        vm.manager_form.cover_image = null;
        vm.manager_form.cover_image_url =
          vm.user.manager_info.profile.cover_photo;

        // Set company data
        vm.company_form.id = vm.user.company_info.id;
        vm.company_form.company_name = vm.user.company_info.company_name;
        vm.company_form.company_domain =
          vm.user.company_info.domain == "null"
            ? ""
            : vm.user.company_info.domain;
        vm.company_form.company_address = vm.user.company_info.address;
        vm.company_form.company_description = vm.user.company_info.description;
        vm.company_form.profile_logo = null;
        vm.company_form.profile_logo_url = vm.user.company_info.company_logo;
      })
      .catch((error) => {});
  },
  computed: {
    ...mapGetters(["getCountries", "getCities"]),
  },
  methods: {
    deleteAccount() {
      let vm = this;
      vm.account_delete_loading = true;
      vm.$store
        .dispatch("DELETE_COMPANY_ACCOUNT", { id: vm.user.manager_info.id })
        .then((response) => {
          vm.account_delete_loading = false;
          window.parent.postMessage({ message: "logoutUser", value: "" }, "*");
        })
        .catch((error) => {
          vm.account_delete_loading = false;
        });
    },
    deleteCompany() {
      let vm = this;
      vm.company_delete_loading = true;
      vm.$store
        .dispatch("DELETE_COMPANY", { id: vm.company_form.id })
        .then((response) => {
          vm.company_delete_loading = false;
          window.parent.postMessage({ message: "logoutUser", value: "" }, "*");
        })
        .catch((error) => {
          vm.company_delete_loading = false;
        });
    },
    updatePassword() {
      let vm = this;
      vm.loading = true;
      if (vm.security_form.new_password == vm.security_form.comfirm_pass) {
        vm.$store
          .dispatch("UPDATE_COMPANY_ACCOUNT_PASSWORD", vm.security_form)
          .then((response) => {
            vm.loading = false;
            vm.$router.push({ path: "/profile/consultant" });
          })
          .catch((error) => {
            vm.loading = false;
          });
      } else {
        vm.loading = false;
        vm.$notify({
          group: "status",
          title: "Something wrong",
          text: "Password does not match.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    submitCompanyInfo() {
      let vm = this;
      vm.loading = true;
      let form_data = new FormData();
      form_data.append("company_name", vm.company_form.company_name);
      form_data.append("company_domain", vm.company_form.company_domain);
      form_data.append("address", vm.company_form.company_address);
      form_data.append(
        "company_description",
        vm.company_form.company_description
      );
      if (vm.company_form.profile_logo) {
        form_data.append(
          "profile_logo",
          vm.company_form.profile_logo,
          vm.company_form.profile_logo.name
        );
      }
      form_data.append("profile_logo_set", vm.company_form.profile_logo_set);

      vm.$store
        .dispatch("UPDATE_COMPANY_INFO", form_data)
        .then((response) => {
          vm.loading = false;
          vm.$emit("onClose", null);
        })
        .catch((error) => {
          vm.loading = false;
        });
    },
    submitManagerInfo() {
      let vm = this;
      vm.loading = true;
      let form_data = new FormData();
      form_data.append("first_name", vm.manager_form.first_name);
      form_data.append("last_name", vm.manager_form.last_name);
      form_data.append("address", vm.manager_form.manager_address);
      form_data.append("phone", vm.manager_form.phone);
      form_data.append(
        "manager_description",
        vm.manager_form.manager_description
      );
      if (vm.manager_form.profile_logo) {
        form_data.append(
          "profile_logo",
          vm.manager_form.profile_logo,
          vm.manager_form.profile_logo.name
        );
      }
      if (vm.manager_form.cover_image) {
        form_data.append(
          "cover_image",
          vm.manager_form.cover_image,
          vm.manager_form.cover_image.name
        );
      } else {
        if (vm.manager_form.default_cover_image) {
          form_data.append(
            "default_cover",
            vm.manager_form.default_cover_image
          );
        }
      }
      form_data.append("profile_logo_set", vm.manager_form.profile_logo_set);
      form_data.append("cover_image_set", vm.manager_form.cover_image_set);

      vm.$store
        .dispatch("UPDATE_MANAGER_INFO", form_data)
        .then((response) => {
          vm.loading = false;
          vm.$emit("onClose", null);
        })
        .catch((error) => {
          vm.loading = false;
        });
    },
    onCancel() {
      let vm = this;
      vm.$emit("onCancel", null);
    },
    onScoll({ target }) {
      // Modify header according to profile scoll
      let vm = this;
      vm.isScoll = true;
    },
    setManagerProfileLogo(file) {
      let vm = this;
      if (file) {
        vm.manager_form.profile_logo = file;
        vm.manager_form.profile_logo_url = "";
        vm.manager_form.profile_logo_set = true;
      } else {
        vm.manager_form.profile_logo_set = false;
      }
    },
    setManagerCoverLogo(file) {
      let vm = this;
      if (file) {
        vm.manager_form.cover_image = file;
        vm.manager_form.cover_image_url = "";
        vm.manager_form.default_cover_image = "";
        vm.manager_form.cover_image_set = true;
      } else {
        vm.manager_form.cover_image_set = false;
      }
    },
    setCompanyProfileLogo(file) {
      let vm = this;
      if (file) {
        vm.company_form.profile_logo = file;
        vm.company_form.profile_logo_url = "";
        vm.company_form.profile_logo_set = true;
      } else {
        vm.company_form.profile_logo_set = false;
      }
    },
    setCoverImage(file_name) {
      let vm = this;
      vm.manager_form.cover_image_url = file_name;
      vm.manager_form.default_cover_image = file_name;
      vm.manager_form.cover_image = null;
      vm.manager_form.cover_image_set = true;
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.company-profile-widget {
  background: rgba($color: #000000, $alpha: 0.5);
  min-height: 500px;
  display: block;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;
  z-index: 999;
  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 45px;
  }
  .company-profile-container {
    padding: 10px;
    border-radius: 5px;
    width: 600px;
    margin: 0 auto;
    .company-profile-body {
      border-radius: 5px;
      margin-bottom: 20px;
      .tabs {
        display: grid;
        grid-template-columns: 25% 25% 25% 25%;
        .tab:nth-child(1) {
          border-top-left-radius: 5px;
        }
        .tab:nth-child(4) {
          border-top-right-radius: 5px;
        }
        .tab {
          background: #cccccc;
          height: 55px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 500ms ease-in-out;
          font-weight: 800;
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 12px;
            text-align: center;
          }
          &.active {
            background: #fff;
            color: #1ba5a4;
            font-weight: 800;
            transition: 500ms ease-in-out;
          }
          &:hover {
            color: #1ba5a4;
          }
        }
      }
      .tab-body {
        background: #fff;
        padding: 15px;
        &.man_info {
          .company-input-group {
            margin-bottom: 40px;
            display: grid;
            grid-column-gap: 20px;
            .input {
              display: flex;
              flex-direction: column;

              .company-input {
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 1px solid #d4d4d4;
                border-radius: 5px;
                min-height: 45px;
                width: 100%;
                padding: 5px 20px;
                color: #000;
                font-size: 14px;
                font-family: "AvenirBook";
              }
              .company-input:focus {
                outline: none;
              }
              label {
                font-size: 15px;
                color: #4d4d4d;
                margin-bottom: 10px;
                display: block;
                font-family: "AvenirBook";
              }
            }
            .uploaded-image-preview {
              padding-top: 15px;
              padding-bottom: 15px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .image-preview {
                outline-style: dashed;
                outline-color: #ccc;
                outline-width: 1px;
                width: 100%;
                height: 170px;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .mdi {
                  color: #ccc;
                  font-size: 40px;
                }
              }
              .btn-upload {
                width: 100%;
                height: 43px;
                border-radius: 5px;
                border: none;
                color: #1885ad;
                font-size: 14px;
                font-family: "AvenirBook";
                outline: none;
              }
            }

            &.col-2 {
              grid-template-columns: 48% 48%;
            }
            &.company-first-row {
              grid-template-columns: 48% 23% 23%;
            }
            &.company-second-row {
              grid-template-columns: 68% 28%;
            }
            &.sec-company-first-row {
              grid-template-columns: 23% 23% 48%;
            }
            &.sec-company-second-row {
              grid-template-columns: 48% 23% 23%;
            }
            &.sec-company-third-row {
              grid-template-columns: 30% 23% 23%;
            }
          }
          .profile-cover-upload-widget {
            display: grid;
            grid-template-columns: 240px calc(98% - 240px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
              grid-row-gap: 50px;
            }
            .profile-image {
              background: #fff;
              height: 283px;
            }
            .cover-image {
              background: #fff;
              .cover-upload-widget {
                background: #fff;
                border-radius: 5px;
                display: flex;
                flex-direction: column;
                height: 283px;
                .cover-upload {
                  height: 114px;
                }
                .default-cover-image {
                  display: flex;
                  height: 100%;
                  overflow-y: auto;
                  padding: 15px;
                  flex-wrap: wrap;
                  .cover-image-item {
                    border: 1px solid #f5f5f5;
                    height: 70px;
                    width: 70px;
                    margin-bottom: 8px;
                    margin-right: 8px;
                    img {
                      width: 100%;
                      object-fit: cover;
                      -webkit-transition: 500ms ease-in-out;
                      transition: 500ms ease-in-out;
                      height: 68px;
                      padding: 4px;
                      &:hover {
                        padding: 8px;
                        cursor: pointer;
                        transition: 500ms ease-in-out;
                      }
                    }
                    &.active {
                      border: 1px solid #1890a9 !important;
                    }
                  }
                }
              }
            }
          }
          .options-widget {
            display: flex;
            margin-top: 30px;
            .btn-save {
              color: #fff;
              outline: none;
              border-radius: 5px;
              padding: 13px 13px;
              width: 100px;
              background-image: linear-gradient(
                267deg,
                #1885ad 103%,
                #04a5a5 0%
              );
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .btn-cancel {
              color: #1ba5a4;
              outline: none;
              padding: 7px;
              width: 100px;
            }
          }
        }
        &.comp_info {
          display: flex;
          flex-direction: column;
          .tab-title {
            font-weight: 800;
            margin-bottom: 15px;
            font-size: 15px;
          }
          .company-input-group {
            margin-bottom: 40px;
            display: grid;
            grid-column-gap: 20px;
            .input {
              display: flex;
              flex-direction: column;
              .company-logo {
                height: 283px;
                width: 250px;
              }
              .company-input {
                background: #ffffff 0% 0% no-repeat padding-box;
                border: 1px solid #d4d4d4;
                border-radius: 5px;
                min-height: 45px;
                width: 100%;
                padding: 5px 20px;
                color: #000;
                font-size: 14px;
                font-family: "AvenirBook";
              }
              .company-input:focus {
                outline: none;
              }
              label {
                font-size: 15px;
                color: #4d4d4d;
                margin-bottom: 10px;
                display: block;
                font-family: "AvenirBook";
              }
            }

            &.col-2 {
              grid-template-columns: 48% 48%;
            }
            &.company-first-row {
              grid-template-columns: 48% 23% 23%;
            }
            &.company-second-row {
              grid-template-columns: 68% 28%;
            }
            &.sec-company-first-row {
              grid-template-columns: 23% 23% 48%;
            }
            &.sec-company-second-row {
              grid-template-columns: 48% 23% 23%;
            }
            &.sec-company-third-row {
              grid-template-columns: 30% 23% 23%;
            }
            &.profile-cover-upload-widget {
              grid-template-columns: 38% 58%;
            }
          }
          .options-widget {
            display: flex;
            margin-top: 30px;
            .btn-save {
              color: #fff;
              outline: none;
              border-radius: 5px;
              padding: 13px 13px;
              width: 100px;
              background-image: linear-gradient(
                267deg,
                #1885ad 103%,
                #04a5a5 0%
              );
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .btn-cancel {
              color: #1ba5a4;
              outline: none;
              padding: 7px;
              width: 100px;
            }
          }
          .consultant-widget {
            .company-profile-body {
              border-radius: 5px;
              background: #ffffff;
              margin-bottom: 20px;
              ul.consultants-items {
                padding-left: 0px;
                list-style: none;
                .consultants-starter {
                  .consultants-item-header {
                    display: flex;
                    justify-content: space-between;
                    .btn-add-member {
                      color: #1ba5a4;
                      font-weight: 800;
                    }
                  }
                }
                .consultants-starter {
                  margin-bottom: 6px;
                  .consultants-item-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 16px 0px;
                    label {
                      color: #000000;
                      font-family: "AvenirBook";
                      font-size: 16px;
                    }
                    .btn-add-assignment {
                      color: #1ba5a4;
                      border: none;
                      padding: 10px 10px;
                      font-size: 14px;
                      outline: none;
                      cursor: pointer;
                      font-family: "AvenirBook";
                      font-style: italic;
                      background: transparent;
                    }
                  }
                  p {
                    color: #131313;
                    font-family: "AvenirBook";
                  }
                }
                .consultants-item {
                  background: #f5f5f5 0% 0% no-repeat padding-box;
                  border-radius: 5px;
                  margin-bottom: 10px;
                  .consultants-item-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 17px 17px;
                    .consultants-item-brand {
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                      img {
                        width: 60px;
                        height: 60px;
                        object-fit: cover;
                        margin-right: 15px;
                      }
                    }
                    .content {
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: space-between;
                      width: 100%;
                      .information {
                        display: flex;
                        flex-direction: column;
                        width: 60%;
                        font-family: "AvenirBook";
                        label {
                          display: block;
                          font-size: 14px;
                          font-family: "AvenirBlack";
                          margin-bottom: 7px;
                          font-weight: 800;
                        }
                        span {
                          color: #808080;
                          font-family: "AvenirBook";
                          font-size: 13px;
                          margin-bottom: 6px;
                        }
                      }
                      .options {
                        width: 40%;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-end;
                        .admin-label {
                          margin-right: 20px;
                          color: #1ba5a4;
                        }
                        .manager-label {
                          margin-right: 20px;
                        }
                      }
                    }
                    .toogle-panel-btn {
                      padding: 1px 40px;
                      font-size: 30px;
                      background: transparent;
                      border: none;
                      outline: none;
                      cursor: pointer;
                      color: #ccc;
                    }
                  }
                  .consultants-item-body {
                    padding: 10px;
                    h4 {
                      font-family: "AvenirBook";
                    }
                    img {
                      width: 100%;
                    }
                    p {
                      font-size: 14px;
                      font-family: "AvenirBook";
                    }
                    label {
                      color: #808080;
                      font-size: 15px;
                      display: block;
                      margin-bottom: 8px;
                      font-family: "AvenirBook";
                    }
                    .skills-widget {
                      display: flex;
                      flex-wrap: wrap;
                      .skill-item {
                        background: #707070 0% 0% no-repeat padding-box;
                        border-radius: 25px;
                        color: #ffffff;
                        font-size: 13px;
                        font-family: "AvenirBook";
                        padding: 5px 22px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                      }
                    }
                    .consultants-info {
                      display: flex;
                      justify-content: space-between;
                      margin-top: 20px;
                      .col-one,
                      .col-two {
                        width: 50%;
                        label {
                          color: #808080;
                          margin-bottom: 3px;
                          margin-top: 20px;
                        }
                        p {
                          color: #000;
                          margin: 0px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        &.sec_info {
          .tab-title {
            font-weight: 800;
            font-size: 15px;
            margin-bottom: 20px;
          }
          .form-widget {
            .input-widget {
              display: grid;
              grid-template-columns: 40% 50%;
              grid-column-gap: 20px;
              .input {
                margin-bottom: 15px;
                label {
                  display: block;
                  .required {
                    color: #1885ad;
                  }
                }
                input {
                  background: #ffffff 0% 0% no-repeat padding-box;
                  border: 1px solid #d4d4d4;
                  border-radius: 5px;
                  min-height: 45px;
                  width: 100%;
                  padding: 5px 20px;
                  color: #000;
                  font-size: 14px;
                  font-family: "AvenirBook";
                }
              }
              .option {
                display: flex;
                align-items: center;
              }
            }
            .form-option {
              display: flex;
              .btn-save {
                color: #fff;
                outline: none;
                border-radius: 5px;
                padding: 7px;
                width: 100px;
                background-image: linear-gradient(
                  267deg,
                  #1885ad 103%,
                  #04a5a5 0%
                );
                display: flex;
                justify-content: center;
              }
              .btn-cancel {
                color: #1ba5a4;
                outline: none;
                padding: 7px;
                width: 100px;
              }
            }
          }
          .other-options {
            display: flex;
            flex-direction: column;
            margin-top: 30px;
            .btn-delete-company,
            .btn-delete-account {
              color: #fff;
              height: 45px;
              width: 200px;
              background: #4d4d4d;
              margin-bottom: 20px;
              border-radius: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        &.term_tab {
          .__logo {
            width: 79px;
            margin-bottom: 28px;
          }
        }
      }
    }
  }
}
.input-flex {
  display: flex;
}
</style>